import React, { Component } from "react";
import Legend from "../../granular/Portal/legend";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {makeStyles , withStyles} from "@material-ui/core/styles/withStyles";
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';

import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import { NavLink } from "react-router-dom";

import { pushLoader } from "actions/main";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

class Mapcontrol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStat: "block",
      poiContent: null,
      checkedA: false,
      typeDraw: "Point",
      drawsave: false,
      drawname: "",
      geojson: [],
      shipTypeString: "n/a",
      expoiinfo: false,
      expanded: "panel1",
      open: true
    };
  }

  UNSAFE_componentWillMount() {
    //this.setState({ picture_url: Avatar });
    // fetchWorkspace()
    //   .then(response => {
    //     this.setState({ workspacedata: response.data.results });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }

    // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }

  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }

  handleClick = () => {
    this.setState({open:!this.state.open});
  };


  render() {
    const {
      classes,
      color,
      logo,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive
    } = this.props;

    return  (
      <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              Nested List Items
            </ListSubheader>
          }

        >

          <ListItem button onClick={this.handleClick}>
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Ship Type" />
            {this.state.open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button  >
                <ListItemIcon>
                  <StarBorder />
                </ListItemIcon>
                <ListItemText primary="Starred" />
              </ListItem>
            </List>
          </Collapse>

        </List>
    )
  }

}


function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel
  };
}

export default (Mapcontrol);
